import React, {useEffect} from 'react'
import clsx from 'clsx';
import apiService from '../../../services/apiService';

// This component is used to render the number of pending messages
const DisplayNumberMessages = ({updateData}) => {

    const [number, setNumber] = React.useState(0);
  
    // This useEffect is runned every 30 seconds and pings the server to ask if there are messages for the user
    useEffect( () => {
      
      const interval = setInterval(() => {
        apiService
        .getUserField('messages')
        .then((response) => setNumber(response.data.length ))
      }, 30000);
      return () => clearInterval(interval);
    },[])

    // This useEffect is used to render insta the number of pending messages at first render of component and not wait five seconds.
    useEffect( () => {
      
      apiService
      .getUserField('messages')
      .then((response) => setNumber(response.data.length ))
    
    },[updateData])
  
  
  
    return(
      <div className = {clsx('circleNotificationContainer')} >
        { number > 0  &&
          <span style={{display: 'flex', justifyContent: 'center',fontSize: '0.8rem', paddingRight: '0.5rem', paddingLeft: '0.5rem'}}> {number}</span>
        }
        </div>
    )
  
}

export default DisplayNumberMessages;